/**
 * 책상형 홈페이의 UI 에 관련된 정의
 * Created by 박주형 on 2023-04-25
 */
import {CITY2, isRegion2, REGION, REGION2, REGION2_DEFAULT} from "./gukeo.const";

export const RECORDER_HELP_BBS_ID = '20';
export const SASEUNG_HELP_BBS_ID = '7';

export const PRELOAD_RATIO = 5;  // 화면 몇개 전에 로딩할 지를 지정함. 클 수록 미리 로딩함.


/**
 * 책상형 홈페이지의 메뉴에 관련된 정의
 *
 * TODO: 하나로 합치는 것을 고려할 것. WORD, DIALECT, PROVERB, MOVIE 등을 굳이 3개로 분리해서 정의해야 할 필요가 있나?
 */
export enum MENU_PAGE {
  NONE,
  WORD,
  WORD_BOOKMARK,
  WORD_HISTORY,
  HOMONYM,
  DIALECT,
  DIALECT_BOOKMARK,
  DIALECT_HISTORY,
  PROVERB,
  PROVERB_BOOKMARK,
  PROVERB_HISTORY,
  SASEUNG,
  SASEUNG_BOOKMARK,
  MOVIE_COLLECT,
  MOVIE_BOOKMARK,
  MOVIE_HISTORY,
  LOANWORD,
  PROPER_WORDING,
  SAJASEUNGEO,
  SAJASEUNGEO_BOOKMARK,
  EXAMPLE_LISTEN,
  EXAMPLE_LISTEN_BOOKMARK,
  OPTIONS,
  REFERENCE,
  BBS_NOTICE,
  BBS_USAGE,
  DONATION,
  OPEN_SOURCE,
  LEGAL_NOTICE,
}


export const PROVERB_PAGE_SIZE = 8;
export const PROVERB_COUNT_WORD_DETAIL = 1; // 단어 상세 화면에 표시할 속담의 갯수
export const EXAMPLE_PAGE_SIZE = 20;
export const ARTICLE_PAGE_SIZE = 24;


export const LINK_POPUP_MEANING = 2; // 링크 팝업에 표시할 뜻의 갯수
export const WORD_LIST_MEANING = 2; // 단어 리스트에 표시할 뜻의 갯수

export const LIST_SCROLL_INTERVAL = 100; // 스크롤 간격 (ms)
export const WORD_SCROLL_SPEED = 200; // 단어와 예문에서 리스트 스크롤 속도
export const HOMONYM_SCROLL_SPEED = 200; // 이운이의어 화면에서 스크롤 속도
export const DIALECT_SCROLL_SPEED = 250; // 지방어 리스트 스크롤 속도


export const DIALECT_LIST_MEANING = 1; // 지방어 리스트에서 간단히 표시할 뜻의 갯수


/************************************************************
 * 책상형 UI에서 사용되는 정의 값
 * WARN: enum REGION 와 순서가 일치해야 한다.
 */


// TODO: 나중에 지워야 함. REGION_INFO2 가 구현 완료되면.
export type REGION_INFO = {
  region: REGION;
  css: string;
  name: string;
  coords?: string;  // image map의 coord 값
};

export const REGION_LIST: Array<REGION_INFO> = [
  {
    region: REGION.ALL,
    css: 'all',
    name: '전全 지역 우리말 모음',
  },
  {
    region: REGION.GANGWON,
    css: '1',   // CSS 는 REGION 값과 일치시킴
    name: '강원도',
    coords: "433,87,408,121,310,118,372,207,369,255,414,249,459,270,523,260",
  },
  {
    region: REGION.GYEONGSANG,
    css: '2',
    name: '경상도',
    coords: "526,260,454,273,378,322,391,373,358,426,352,490,384,550,453,544,506,494,542,390",
  },
  {
    region: REGION.JEONLA,
    css: '3',
    name: '전라도',
    coords: "262,393,295,379,374,394,351,471,380,548,272,594,207,586,192,530",
  },
  {
    region: REGION.JEJU,
    css: '4',
    name: '제주도',
    coords: "258,622,227,641,235,658,273,662,308,647,318,630,307,615",
  },
  {
    region: REGION.CHUNGCHEONG,
    css: '5',
    name: '충청도',
    coords: "211,306,264,391,294,376,379,392,396,372,379,321,452,271,400,244,291,292,256,263",
  },
];


export function GetRegionByEnum(region: REGION): REGION_INFO|null {
  return (0 <= region && region < REGION.MAX) ? REGION_LIST[region] : null;
}

export function GetRegionText(region: REGION): string | null {
  const regionInfo = GetRegionByEnum(region);
  return regionInfo ? regionInfo.name : null;
}

export function GetRegionByText(text: string): REGION_INFO | null {
  const idx = REGION_LIST.findIndex(value => value.name === text);
  return idx === -1 ? null : REGION_LIST[idx];
}

export function GetRegionCss(region: REGION): string | null {
  const regionInfo = GetRegionByEnum(region);
  return regionInfo ? regionInfo.css : null;
}


/************************************************************
 * 지역 정보 버전2
 */

export const CSS_REGION_ALL = '0';
export const CSS_REGION_GANGWON = '1';
export const CSS_REGION_GYEONGSANG = '2';
export const CSS_REGION_JEONLA = '3';
export const CSS_REGION_JEJU = '4';
export const CSS_REGION_CHUNGCHEONG = '5';



export type REGION_INFO2 = {
  region2: REGION2;
  region: REGION;
  css: string;
  cssPos: string; // 위치 지정용 CSS
  name: string;
};

export const REGION_INFO2_LIST: Array<REGION_INFO2> = [
  { region2: '강원', cssPos: '1', region: REGION.GANGWON, css: CSS_REGION_GANGWON, name: '강원도' },
  { region2: '경남', cssPos: '3', region: REGION.GYEONGSANG, css: CSS_REGION_GYEONGSANG, name: '경상남도' },
  { region2: '경북', cssPos: '2', region: REGION.GYEONGSANG, css: CSS_REGION_GYEONGSANG, name: '경상북도' },
  { region2: '전남', cssPos: '5', region: REGION.JEONLA, css: CSS_REGION_JEONLA, name: '전라남도' },
  { region2: '전북', cssPos: '4', region: REGION.JEONLA, css: CSS_REGION_JEONLA, name: '전라북도' },
  { region2: '제주', cssPos: '6', region: REGION.JEJU, css: CSS_REGION_JEJU, name: '제주도' },
  { region2: '충남', cssPos: '8', region: REGION.CHUNGCHEONG, css: CSS_REGION_CHUNGCHEONG, name: '충청남도' },
  { region2: '충북', cssPos: '7', region: REGION.CHUNGCHEONG, css: CSS_REGION_CHUNGCHEONG, name: '충청북도' },
  { region2: '전국', cssPos: '0', region: REGION.ALL, css: CSS_REGION_ALL, name: '전全&nbsp;지역' },
];

export const REGION_INFO2_MAP: Map<REGION2, REGION_INFO2> = new Map(
  REGION_INFO2_LIST.map(item => [item.region2, item])
);


export function GetRegion2Css(region: string): string {
  region = isRegion2(region) ? region : REGION2_DEFAULT;
  return REGION_INFO2_MAP.get(region as REGION2)?.css ?? '0';
}

export function GetRegion2CssPos(region: string): string {
  region = isRegion2(region) ? region : REGION2_DEFAULT;
  return REGION_INFO2_MAP.get(region as REGION2)?.cssPos ?? '0';
}


export function GetRegion2Name(region: string): string {
  region = isRegion2(region) ? region : REGION2_DEFAULT;
  return REGION_INFO2_MAP.get(region as REGION2)?.name ?? '전全 지역';
}



/************************************************************
 *
 */

export type CITY2_INFO = {
  city2: CITY2;
  css: string;  // color 지정용
  cssPos: string; // 도시 위치 지정용
  region: REGION;
  region2: REGION2;
  display: string;
  listTxt: string;  // 목록에 표시
};

export const CITY2_INFO_LIST: Array<CITY2_INFO> = [
  {
    city2: '강릉',
    cssPos: '1',
    css: CSS_REGION_GANGWON,
    region: REGION.GANGWON,
    region2: '강원',
    display: '강릉',
    listTxt: '강원도 강릉',
  },
  {
    city2: '대구',
    cssPos: '2',
    css: CSS_REGION_GYEONGSANG,
    region: REGION.GYEONGSANG,
    region2: '경북',
    display: '대구',
    listTxt: '경상도 대구',
  },
  {
    city2: '부산',
    cssPos: '3',
    css: CSS_REGION_GYEONGSANG,
    region: REGION.GYEONGSANG,
    region2: '경남',
    display: '부산',
    listTxt: '경상도 부산',
  },
  {
    city2: '포항',
    cssPos: '4',
    css: CSS_REGION_GYEONGSANG,
    region: REGION.GYEONGSANG,
    region2: '경북',
    display: '포항',
    listTxt: '경상도 포항',
  },
  {
    city2: '하동',
    cssPos: '5',
    css: CSS_REGION_GYEONGSANG,
    region: REGION.GYEONGSANG,
    region2: '경남',
    display: '하동',
    listTxt: '경상도 하동',
  },
  {
    city2: '광주',
    cssPos: '6',
    css: CSS_REGION_JEONLA,
    region: REGION.JEONLA,
    region2: '전남',
    display: '광주',
    listTxt: '전라도 광주',
  },
  {
    city2: '전주',
    cssPos: '7',
    css: CSS_REGION_JEONLA,
    region: REGION.JEONLA,
    region2: '전북',
    display: '전주',
    listTxt: '전라도 전주',
  },
  {
    city2: '대전',
    cssPos: '8',
    css: CSS_REGION_CHUNGCHEONG,
    region: REGION.CHUNGCHEONG,
    region2: '충남',
    display: '대전',
    listTxt: '충청도 대전',
  },
  {
    city2: '서산',
    cssPos: '9',
    css: CSS_REGION_CHUNGCHEONG,
    region: REGION.CHUNGCHEONG,
    region2: '충남',
    display: '서산',
    listTxt: '충청도 서산',
  },
  {
    city2: '제천',
    cssPos: '10',
    css: CSS_REGION_CHUNGCHEONG,
    region: REGION.CHUNGCHEONG,
    region2: '충북',
    display: '제천',
    listTxt: '충청도 제천',
  },
  {
    city2: '전국',
    cssPos: '0',
    css: CSS_REGION_ALL,
    region: REGION.ALL,
    region2: '전국',
    display: '전全&nbsp;지역',
    listTxt: '전全&nbsp;지역',
  },
];

export const CITY2_INFO_MAP: Map<CITY2, CITY2_INFO> = new Map(
  CITY2_INFO_LIST.map(item => [item.city2, item])
);

export function GetCity2Css(city2: string): string {
  return CITY2_INFO_MAP.get(city2 as CITY2)?.css ?? '0';
}

export function GetCity2Css2(city2: string): string {
  return CITY2_INFO_MAP.get(city2 as CITY2)?.cssPos ?? '0';
}

export function GetCity2DisplayTxt(city2: string): string {
  return CITY2_INFO_MAP.get(city2 as CITY2)?.display ?? '전全&nbsp;지역';
}


/******************************************************************************
 * 화면 크기 조정 및 스크롤 관련 정의
 ******************************************************************************/

export const EXT_HEIGHT_CAL = 56; // 화면 크기 계산 시 보정값 (px)

export const BODY_HEIGHT_VALUE = 634; // 화면 크기 계산 시 기준값 (px)
export const BODY_HEIGHT_CAL = 34; // 화면 크기 계산 시 보정값 (px)

export const SIDE_HEIGHT_DELTA = 14;  // 책 사이드 이미지의 높이 보정값 (px)
                                      // 책 사이드를 BODY_HEIGHT_VALUE 와 동일한 값을 주면 삐져나온다.



/******************************************************************************
 *
 ******************************************************************************/
